var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.services.group || _vm.services.rooms
    ? _c(
        "div",
        { staticClass: "row border-radius bg-white padding-flex mb-1" },
        [
          _c("div", { staticClass: "col-md-12 estate-service" }, [
            _c(
              "div",
              {
                staticClass:
                  "row bg-white radius marginTop25 descriptionContent services"
              },
              [
                _c("div", { staticClass: "col-sm-12 descriptionTextCont" }, [
                  _c(
                    "h2",
                    [
                      _c("masked-image", {
                        staticClass: "icon_title",
                        attrs: { src: "/img/icons/features.svg" }
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm._f("capitalize")(_vm.trans("labels.other_char"))
                          ) +
                          "\n                "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-1" }, [
                    _vm.services.group
                      ? _c(
                          "div",
                          { staticClass: "marginTop15" },
                          _vm._l(_vm.services.group, function(service, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "tag" },
                              [
                                _c("tooltip", {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "outer",
                                        fn: function() {
                                          return [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(service["nome-macro"]) +
                                                "\n                                    "
                                            ),
                                            service.option
                                              ? _c("img", {
                                                  attrs: {
                                                    src:
                                                      "/img/icons/service-note.svg",
                                                    width: "15"
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        },
                                        proxy: true
                                      },
                                      service.option
                                        ? {
                                            key: "inner",
                                            fn: function() {
                                              return [
                                                service["nome-micro"]
                                                  ? [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "capitalize"
                                                            )(
                                                              _vm.trans(
                                                                "labels.features"
                                                              )
                                                            )
                                                          ) + ":"
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "ul",
                                                        _vm._l(
                                                          service["nome-micro"],
                                                          function(nameMicro) {
                                                            return _c("li", [
                                                              _vm._v(
                                                                "\n                                                " +
                                                                  _vm._s(
                                                                    nameMicro
                                                                  ) +
                                                                  "\n                                            "
                                                              )
                                                            ])
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                service["nome-descrizione"]
                                                  ? [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "capitalize"
                                                            )(
                                                              _vm.trans(
                                                                "labels.description"
                                                              )
                                                            )
                                                          ) + ":"
                                                        )
                                                      ]),
                                                      _c("br"),
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            service[
                                                              "nome-descrizione"
                                                            ]
                                                          ) +
                                                          "\n                                    "
                                                      )
                                                    ]
                                                  : _vm._e()
                                              ]
                                            },
                                            proxy: true
                                          }
                                        : null
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.services.rooms
                      ? _c(
                          "div",
                          { staticClass: "mt-1" },
                          [
                            _vm.services.group
                              ? [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("capitalize")(
                                          _vm.trans("labels.desc_locals")
                                        )
                                      ) + ":"
                                    )
                                  ]),
                                  _c("br")
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.services.rooms, function(
                              service,
                              index
                            ) {
                              return _c(
                                "div",
                                { key: index, staticClass: "tag" },
                                [
                                  _c("tooltip", {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "outer",
                                          fn: function() {
                                            return [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    service["nome-categoria"]
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    service["nome-macro"]
                                                  ) +
                                                  "\n                                    "
                                              ),
                                              service.option
                                                ? _c("img", {
                                                    attrs: {
                                                      src:
                                                        "/img/icons/service-note.svg",
                                                      width: "15"
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          },
                                          proxy: true
                                        },
                                        service["nome-micro"] ||
                                        service["nome-descrizione"]
                                          ? {
                                              key: "inner",
                                              fn: function() {
                                                return [
                                                  service["nome-micro"]
                                                    ? [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "capitalize"
                                                              )(
                                                                _vm.trans(
                                                                  "labels.features"
                                                                )
                                                              )
                                                            ) + ":"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c(
                                                          "ul",
                                                          _vm._l(
                                                            service[
                                                              "nome-micro"
                                                            ],
                                                            function(
                                                              nameMicro
                                                            ) {
                                                              return _c("li", [
                                                                _vm._v(
                                                                  "\n                                                " +
                                                                    _vm._s(
                                                                      nameMicro
                                                                    ) +
                                                                    "\n                                            "
                                                                )
                                                              ])
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  service["nome-descrizione"]
                                                    ? [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "capitalize"
                                                              )(
                                                                _vm.trans(
                                                                  "labels.description"
                                                                )
                                                              )
                                                            ) + ":"
                                                          )
                                                        ]),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\n                                        " +
                                                            _vm._s(
                                                              service[
                                                                "nome-descrizione"
                                                              ]
                                                            ) +
                                                            "\n                                    "
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ]
                                              },
                                              proxy: true
                                            }
                                          : null
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ])
              ]
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }